<template>
  <svg class="summary-icon" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M11.1667 2.37301V1.33301C11.1667 1.05967 10.94 0.833008 10.6667 0.833008C10.3933 0.833008 10.1667 1.05967 10.1667 1.33301V2.33301H5.83332V1.33301C5.83332 1.05967 5.60666 0.833008 5.33332 0.833008C5.05999 0.833008 4.83332 1.05967 4.83332 1.33301V2.37301C3.03332 2.53967 2.15999 3.61301 2.02666 5.20634C2.01332 5.39967 2.17332 5.55967 2.35999 5.55967H13.64C13.8333 5.55967 13.9933 5.39301 13.9733 5.20634C13.84 3.61301 12.9667 2.53967 11.1667 2.37301Z"
      :fill="props.primaryColor"
    />
    <path
      opacity="0.4"
      d="M13.3333 6.55957C13.7 6.55957 14 6.85957 14 7.22624V11.3329C14 13.3329 13 14.6662 10.6667 14.6662H5.33333C3 14.6662 2 13.3329 2 11.3329V7.22624C2 6.85957 2.3 6.55957 2.66667 6.55957H13.3333Z"
      :fill="props.secondaryColor"
    />
    <path
      d="M5.66667 9.99959C5.49333 9.99959 5.32 9.92625 5.19333 9.80625C5.07333 9.67958 5 9.50626 5 9.33292C5 9.15959 5.07333 8.98626 5.19333 8.8596C5.38 8.67293 5.67333 8.61291 5.92 8.71958C6.00667 8.75291 6.08 8.7996 6.14 8.8596C6.26 8.98626 6.33333 9.15959 6.33333 9.33292C6.33333 9.50626 6.26 9.67958 6.14 9.80625C6.01333 9.92625 5.84 9.99959 5.66667 9.99959Z"
      :fill="props.primaryColor"
    />
    <path
      d="M8.00016 9.99959C7.82683 9.99959 7.6535 9.92625 7.52683 9.80625C7.40683 9.67958 7.3335 9.50626 7.3335 9.33292C7.3335 9.15959 7.40683 8.98626 7.52683 8.8596C7.58683 8.7996 7.66016 8.75291 7.74683 8.71958C7.9935 8.61291 8.28683 8.67293 8.4735 8.8596C8.5935 8.98626 8.66683 9.15959 8.66683 9.33292C8.66683 9.50626 8.5935 9.67958 8.4735 9.80625C8.44016 9.83292 8.40683 9.85958 8.3735 9.88625C8.3335 9.91291 8.2935 9.93293 8.2535 9.94627C8.2135 9.96627 8.1735 9.9796 8.1335 9.98626C8.08683 9.99293 8.04683 9.99959 8.00016 9.99959Z"
      :fill="props.primaryColor"
    />
    <path
      d="M10.3332 10.0003C10.1598 10.0003 9.9865 9.92699 9.85984 9.80699C9.73984 9.68033 9.6665 9.507 9.6665 9.33367C9.6665 9.16033 9.73984 8.98701 9.85984 8.86034C9.9265 8.80034 9.99317 8.75366 10.0798 8.72032C10.1998 8.66699 10.3332 8.65366 10.4665 8.68033C10.5065 8.68699 10.5465 8.70032 10.5865 8.72032C10.6265 8.73366 10.6665 8.75368 10.7065 8.78034C10.7398 8.80701 10.7732 8.83367 10.8065 8.86034C10.9265 8.98701 10.9998 9.16033 10.9998 9.33367C10.9998 9.507 10.9265 9.68033 10.8065 9.80699C10.7732 9.83366 10.7398 9.86032 10.7065 9.88699C10.6665 9.91366 10.6265 9.93368 10.5865 9.94701C10.5465 9.96701 10.5065 9.98034 10.4665 9.98701C10.4198 9.99367 10.3732 10.0003 10.3332 10.0003Z"
      :fill="props.primaryColor"
    />
    <path
      d="M5.66667 12.3333C5.58 12.3333 5.49333 12.3134 5.41333 12.28C5.32667 12.2467 5.26 12.2 5.19333 12.14C5.07333 12.0133 5 11.84 5 11.6667C5 11.4933 5.07333 11.32 5.19333 11.1933C5.26 11.1333 5.32667 11.0867 5.41333 11.0533C5.53333 11 5.66667 10.9867 5.8 11.0133C5.84 11.02 5.88 11.0333 5.92 11.0533C5.96 11.0667 6 11.0867 6.04 11.1134C6.07333 11.14 6.10667 11.1667 6.14 11.1933C6.26 11.32 6.33333 11.4933 6.33333 11.6667C6.33333 11.84 6.26 12.0133 6.14 12.14C6.10667 12.1667 6.07333 12.2 6.04 12.22C6 12.2467 5.96 12.2667 5.92 12.28C5.88 12.3 5.84 12.3133 5.8 12.32C5.75333 12.3267 5.71333 12.3333 5.66667 12.3333Z"
      :fill="props.primaryColor"
    />
    <path
      d="M8.00016 12.3338C7.82683 12.3338 7.6535 12.2604 7.52683 12.1404C7.40683 12.0138 7.3335 11.8405 7.3335 11.6671C7.3335 11.4938 7.40683 11.3205 7.52683 11.1938C7.7735 10.9471 8.22683 10.9471 8.4735 11.1938C8.5935 11.3205 8.66683 11.4938 8.66683 11.6671C8.66683 11.8405 8.5935 12.0138 8.4735 12.1404C8.34683 12.2604 8.1735 12.3338 8.00016 12.3338Z"
      :fill="props.primaryColor"
    />
    <path
      d="M10.3332 12.3338C10.1598 12.3338 9.9865 12.2604 9.85984 12.1404C9.73984 12.0138 9.6665 11.8405 9.6665 11.6671C9.6665 11.4938 9.73984 11.3205 9.85984 11.1938C10.1065 10.9471 10.5598 10.9471 10.8065 11.1938C10.9265 11.3205 10.9998 11.4938 10.9998 11.6671C10.9998 11.8405 10.9265 12.0138 10.8065 12.1404C10.6798 12.2604 10.5065 12.3338 10.3332 12.3338Z"
      :fill="props.primaryColor"
    />
  </svg>
</template>

<script setup>
/* global defineProps */
const props = defineProps({
  primaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryOpacity: {
    type: Number,
    default: 0.4
  }
})

</script>
